export default __webpack_public_path__ + "static/media/Inter.aadb65ac.ttf";